import projectMap from './ProjectMap';
import directory from './Directory'
import projectEdit from './ProjectEdit';
import partnerContact from './PartnerContact';

export const ProjectMap = projectMap;
export const Directory = directory;

export const ProjectEdit = projectEdit;
export const PartnerContact = partnerContact;
